export default class EmailValidationError extends Error {
  constructor() {
    super('El correo ingresado no es válido. Por favor, verifique e intente nuevamente.');
    this.name = 'EmailValidationError';
  }
}
